export const RoleId = {
  CB: 1,
}

export const FunctionId = {
  CB: 1,
}

export const Roles = {
  CB: {
    functionId: FunctionId.CB,
    roleId: RoleId.CB,
  },
}
